import { Injectable, inject } from '@angular/core';

import { IConstant } from '@frontend/oxygen/shared-utils';
import { Observable, Subject } from 'rxjs';

import { EnvironmentConfig } from '../../../../client-config/index';
import { CmsService } from '../../../../core/services/cms/cms.service';
import { IStreamBetWeb, ISystemConfig } from '../../../../core/services/cms/models/system-config';

@Injectable({ providedIn: 'root' })
export class EventVideoStreamProviderService {
    snbVideoFullScreenExitSubj: Subject<void> = new Subject<void>();
    private playVideoObservable: Subject<void>;
    private playSucessObservable: Subject<boolean>;
    private hideStreamObservable: Subject<boolean>;
    isStreamAndBet: boolean;
    streamBetWeb: IStreamBetWeb;
    private readonly environment = inject(EnvironmentConfig).configuration;

    constructor(private cmsService: CmsService) {
        this.playVideoObservable = new Subject<void>();
        this.playSucessObservable = new Subject<boolean>();
        this.hideStreamObservable = new Subject<boolean>();
    }

    get playListener(): Subject<void> {
        return this.playVideoObservable;
    }
    set playListener(value: Subject<void>) {}

    get playSuccessErrorListener(): Subject<boolean> {
        return this.playSucessObservable;
    }
    set playSuccessErrorListener(value: Subject<boolean>) {}
    get showHideStreamListener(): Subject<boolean> {
        return this.hideStreamObservable;
    }
    set showHideStreamListener(value: Subject<boolean>) {}

    isStreamBetAvailable(streamBetConfig: IConstant, location: string): boolean {
        const isStreamBetAvailableIntial =
            streamBetConfig.streamBetCmsConfig?.enabled &&
            streamBetConfig.streamBetCmsConfig.sportIds?.indexOf(streamBetConfig.categoryId.toString()) > -1 &&
            this.isStreamAllowed(streamBetConfig) &&
            streamBetConfig.isMobile &&
            !streamBetConfig.isTablet &&
            !streamBetConfig.isDesktop;
        if (location === 'EventVideoStreamComponent') {
            return (
                (streamBetConfig.categoryId.toString() === this.environment.HORSE_RACING_CATEGORY_ID ? streamBetConfig.isIHR : true) &&
                isStreamBetAvailableIntial &&
                streamBetConfig.providerInfoAvailable &&
                !streamBetConfig.isMyBets
            );
        }
        return streamBetConfig.categoryId.toString() === this.environment.HORSE_RACING_CATEGORY_ID && location === 'racingEventMain'
            ? isStreamBetAvailableIntial && streamBetConfig.isIHR
            : isStreamBetAvailableIntial;
    }

    private isStreamAllowed(streamBetConfig: IConstant): boolean {
        const providerName = streamBetConfig.providerInfo.priorityProviderName || this.priorityProviderName(streamBetConfig.providerInfo);
        const isStreamConfiguredInCms = streamBetConfig.streamBetCmsConfig.streamProviders.includes(providerName);

        // if stream is not configured in cms OR if its perform stream and sport is Horse racing, Don't allow.
        if (
            !isStreamConfiguredInCms ||
            (providerName === 'Perform' && this.environment.HORSE_RACING_CATEGORY_ID === streamBetConfig.categoryId.toString())
        )
            return false;

        return true;
    }

    private priorityProviderName(providerInfo: Record<string, any>): string {
        const priorityProviderName = providerInfo.IMG
            ? 'IMG Video Streaming'
            : providerInfo.ATR
              ? 'At The Races'
              : providerInfo.iGameMedia
                ? 'iGame Media'
                : providerInfo.Perform
                  ? 'Perform'
                  : '';
        return priorityProviderName;
    }

    getStreamBetCmsConfig(): Observable<ISystemConfig> {
        return this.cmsService.getFeatureConfig('StreamBetWeb');
    }
}
